import ProjectList from "../Project";


export default function HistoryProjects() {
    return <ProjectList isHistory />
}